<template>
	<div class="card">
    <div class="card-body">
      <div v-if="cargando">
        <div class="d-flex justify-content-center">
          <div class="spinner-border m-5" role="status">
            <span class="sr-only">{{ $t("page.general.cargar") }}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-12 text-center">
            <h5>{{ $t("page.curso_instructor.cursos_impartidos") }}</h5>
          </div>
          <div class="col-12">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col" class="text-center">{{ $t("page.curso_instructor.nombre_curso") }}</th>
                  <th scope="col" class="text-center">{{ $t("page.curso_instructor.fecha") }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colspan="2" class="text-center" v-if="cursos.length==0">
                    <h6 class="mr-4">{{ $t("page.curso_instructor.sin_cursos") }}</h6>
                  </td>
                </tr>
                <tr v-for="curso,index of cursos" :key="index+'curso'">
                  <td scope="row">{{curso.nombre_corto}}</td>
                  <td>
                    {{curso.fecha_curso}}
                  </td>
                  <td>
                    <button
                      :class="
                        {
                          'btn_blue' : curso.comentarios_instructor.length>0,
                          'btn-secondary' : curso.comentarios_instructor.length==0
                        }
                      "
                      :disabled="cargando_comentarios"
                      v-on:click="Comentarios(curso)"
                      class="btn btn-sm">
                      <i
                        v-if="cargando_comentarios"
                        class="fas fa-spinner fa-spin" />
                      <i
                        v-else
                        class="fas fa-comment-dots" />
                      {{ $t("page.curso_instructor.mis_comentarios") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modal_comentarios_instructor" tabindex="-1" role="dialog" aria-labelledby="modal_comentarios_instructorLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modal_comentarios_instructorLabel">{{curso.cve_curso}} - {{curso.nombre}}</h5>
            <button type="button" id="cerrar_modal_comentarios_instructor" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="!cargando_comentarios" class="row">
              <div class="form-group col-12 text-center">
                <label for="comentarios">{{ $t("page.curso_instructor.comentarios") }}</label>
                <textarea
                  :disabled="curso.curso_cerrado==1"
                  class="form-control"
                  placeholder="Escribe tus comentarios del curso"
                  id="comentarios"
                  v-model="curso.comentarios_instructor"
                  rows="6" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              :disabled="cargando_guardar_comentarios"
              class="btn btn-danger"
              data-dismiss="modal">
              {{ $t("page.curso_instructor.cerrar") }}
            </button>
            <button
              type="button"
              v-if="curso.curso_cerrado==0"
              class="btn btn-success"
              :disabled="cargando_guardar_comentarios"
              v-on:click="Guardar">
              <i
                v-if="cargando_guardar_comentarios"
                class="fas fa-spinner fa-spin" />
              {{ $t("page.curso_instructor.guardar") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data () {
      return {
        cargando:true,
        cargando_comentarios:false,
        cargando_guardar_comentarios:false,
        cursos:[],
        curso:{
          cve_curso:null,
          comentarios_instructor:""
        }
      }
    },
    methods:{
      Cerrar_Modal_Comentarios(){
        $('#modal_comentarios_instructor').modal('hide');
      },
      Guardar(){
        if (this.curso.comentarios_instructor.length==0) {
          swal('Comentario Obligatorio','','warning');
          return;
        }
        this.cargando_guardar_comentarios=true;
        this.$http.post('dashboard/cursos_instructor',{
          curso:this.curso
        })
        .then(respuesta=>{return respuesta.json()})
        .then(respuestaJson=>{
          if (respuestaJson.resp=='Excelente') {
            this.Cerrar_Modal_Comentarios();
            this.Consultar();
            swal('Excelente','Comentarios Guardados','success');
          }else{
            swal('Ups',respuestaJson.resp,'error');
          }
        })
        .catch(error=>{
          swal('Ups','Problemas para enviar los comentarios','error');
        })
        .finally(response=>{
          this.cargando_guardar_comentarios=false;
        });
      },
        Comentarios(curso){
          var that=this;
          this.cargando_comentarios=true;
          this.curso=curso;
          $('#modal_comentarios_instructor').modal();
          $(document).ready(function(){
            that.cargando_comentarios=false;
          });
          console.log(this.curso);
        },
        Consultar(){
          this.cargando=true;
          this.$http.get('dashboard/cursos_instructor')
          .then(respuesta=>{return respuesta.json()})
          .then(respuestaJson=>{
            this.cursos=respuestaJson;
          })
          .finally(response=>{
            this.cargando=false;
          });
        },
        Cargando(){
            this.result="d-none";
            this.loading="";
        },
        Listo(){
            this.result="";
            this.loading="d-none";
        }
    },
    mounted(){
        this.Consultar();
    },
    computed:{
        menu(){
          return this.$store.getters.getMenu;
        },
        usuario(){
          return this.$store.getters.getUsuario;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/MisCursosInstructor/MisCursosInstructor.vue